const BlowinInTheWind = [
	'[Verse 1]',
	'How many roads must a man walk down,',
	'before you call him a man?',
	'How many seas must a white dove sail,',
	'before she sleeps in the sand?',
	'Yes, and how many times must the cannonballs fly,',
	"before they're forever banned?",
	'',
	'[Chorus]',
	"The answer, my friend, is blowin' in the wind",
	"The answer is blowin' in the wind.",
	'',
	'[Verse 2]',
	'Yes, and how many years can a mountain exist,',
	'before it is washed to the sea?',
	'Yes, and how many years can some people exist,',
	"before they're allowed to be free?",
	'Yes, and how many times can a man turn his head,',
	"and pretend that he just doesn't see?",
	'',
	'[Chorus]',
	"The answer, my friend, is blowin' in the wind",
	"The answer is blowin' in the wind.",
	'',
	'[Verse 3]',
	'Yes, and how many times must a man look up,',
	'before he can see the sky?',
	'Yes, and how many ears must one man have,',
	'before he can hear people cry?',
	"Yes, and how many deaths will it take 'til he knows,",
	'that too many people have died?',
	'',
	'[Chorus]',
	"The answer, my friend, is blowin' in the wind",
	"The answer is blowin' in the wind.",
];

export default BlowinInTheWind;
